import React, { Component, Fragment } from "react";
import { Link, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { register } from "../../actions/users";
import { setAlert } from "../../actions/alerts";

class Register extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      username: "",
      phone: "",
      network: "",
      password: "",
      confirmPassword: "",
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  handleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  handleSubmit(e) {
    e.preventDefault()
    if(this.state.email === '') {
      this.props.setAlert('Email is required', 'danger')
      return
    } 
    if(this.state.username === '') {
      this.props.setAlert('Username is required', 'danger')
      return
    } 
    if(this.state.password === '') {
      this.props.setAlert('Passwords is required', 'danger')
      return
    } 
    if(this.state.confirmPassword === '') {
      this.props.setAlert('Please confirm password', 'danger')
      return
    } 
    if(this.state.password === '') {
      this.props.setAlert('Network is required', 'danger')
      return
    } 

      this.props.register(
        this.state.email,
        this.state.username,
        this.state.password,
        this.state.confirmPassword,
        this.state.phone,
        this.state.network
      );
    
  }
  render() {
    if (this.props.auth) {
      return <Redirect to="/dashboard" />;
    }
    return (
      <Fragment>
        <div className="oi-flex-wrapper">
          <div className="oi-flex-content">
            <div className="oi-card">
              <div className="form-wrapper">
                <div className="oi-form-group">
                  <label className="secondary-header-text" htmlFor="email">
                    Email
                  </label>
                  <input
                    className="oi-input"
                    type="text"
                    name="email"
                    placeholder="Enter your email"
                    value={this.state.email}
                    onChange={this.handleChange}
                    required
                  />
                  {/* <small className="form-error">Required field</small> */}
                </div>

                <div className="oi-form-group margin-top-big">
                  <label className="secondary-header-text" htmlFor="email">
                    Username
                  </label>
                  <input
                    className="oi-input"
                    type="text"
                    name="username"
                    placeholder="Enter your username"
                    value={this.state.username}
                    onChange={this.handleChange}
                    required
                  />
                  {/* <small className="form-error">Required field</small> */}
                </div>
                <div className="oi-form-group margin-top-big">
                  <label className="secondary-header-text" htmlFor="email">
                    Phone Number
                  </label>
                  <input
                    className="oi-input"
                    type="text"
                    name="phone"
                    placeholder="Enter your phone number"
                    value={this.state.phone}
                    onChange={this.handleChange}
                    required
                  />
                  {/* <small className="form-error">Required field</small> */}
                </div>

                <div className="oi-form-group margin-top-big">
                  <label className="secondary-header-text" htmlFor="email">
                    Password
                  </label>
                  <input
                    className="oi-input"
                    type="password"
                    name="password"
                    placeholder="Enter your password"
                    value={this.state.password}
                    onChange={this.handleChange}
                    minLength="6"
                  />
                  {/* <small className="form-error">Required field</small> */}
                </div>
                <div className="oi-form-group margin-top-big">
                  <label className="secondary-header-text" htmlFor="email">
                    Confirm Password
                  </label>
                  <input
                    className="oi-input"
                    type="password"
                    name="confirmPassword"
                    placeholder="Confirm your password"
                    value={this.state.confirmPassword}
                    onChange={this.handleChange}
                    minLength="6"
                  />
                  {/* <small className="form-error">Required field</small> */}
                </div>
                <div className="oi-form-group margin-top-big">
                  <label className="secondary-header-text" htmlFor="email">
                    Network
                  </label>
                  <select
                    className="oi-select"
                    name="network"
                    value={this.state.network}
                    onChange={this.handleChange}
                    required
                  >
                    <option value="mtn">MTN</option>
                    <option value="glo">GLO</option>
                    <option value="etisalat">ETISALAT</option>
                    <option value="airtel">AIRTEL</option>
                  </select>
                  {/* <small className="form-error">Required field</small> */}
                </div>
                <div className="button-wrapper">
                  <button
                    onClick={this.handleSubmit}
                    className="oi-button oi-big-button margin-top-small"
                  >
                    Register
                  </button>
                  <p className="link-information">
                    Already have an account?{" "}
                    <Link className="btn-link link-text" to="/">
                      Login
                    </Link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}
const mapStateToProps = (state) => ({
  auth: state.users.isAuthenticated,
});
export default connect(mapStateToProps, { register, setAlert })(Register);
